import { Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip } from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import { NewUserAlert } from './';
import { UserPharmacyQualified } from './';

@observer
class AlertController extends React.Component<any> {
    public getAlertContent = (alertReference: string) => {
        switch (alertReference) {
            case ('new_user'): {
                return <NewUserAlert alert_row={this.props.alert_row} />
            }
            case ('user_pharmacy_qualified'): {
                return <UserPharmacyQualified alert_row={this.props.alert_row} />
            }
            default: {
                return <div>default alert</div>
            }
        }
    }
    public render() {

        return (
            <React.Fragment>
                {this.getAlertContent(this.props.alert_row.AlertReference)}
            </React.Fragment>  
        );
    }
}

export default (
    withRouter(AlertController)
);


// WEBPACK FOOTER //
// ./src/modules/dashboard/Widgets/Alerts/AlertController.tsx